import React from 'react';

/** Original tall drip + shorter alternate (viewBox sizes for img ratio) */
const DRIP_ASSETS = {
  primary: { file: 'paint-drip.svg', w: 295.17, h: 174.74 },
  alt: { file: 'paint-drip2.svg', w: 295.11, h: 118.1 },
};

/**
 * Final vertical layout (keep in sync with App.css `.info-drip-border` + keyframes):
 * - Whole row: translateY −clamp(0.15rem, 1.5vw, 0.55rem) on `.info-drip-border`
 * - Per-img extraY (px), after settle (scaleX 0.86, scaleY 0.648): tiles 1–4 → 0, −11, 0, −9
 * - Tiles alternate primary / alt SVG; load: scaleY stretch from top; duration per tile (durationSec).
 */
const DRIP_TILES = [
  { flip: false, extraY: 0, durationSec: 5.45, asset: 'primary' },
  { flip: true, extraY: -11, durationSec: 6.55, asset: 'alt' },
  { flip: false, extraY: 0, durationSec: 5.9, asset: 'primary' },
  { flip: true, extraY: -9, durationSec: 6.2, asset: 'alt' },
];

export default function InfoDripBorder() {
  const base = process.env.PUBLIC_URL || '';

  return (
    <div className="info-drip-border" aria-hidden="true">
      {DRIP_TILES.map(({ flip, extraY, durationSec, asset }, i) => {
        const { file, w, h } = DRIP_ASSETS[asset];
        const src = `${base}/images/graphics/${file}`;
        return (
          <div
            key={i}
            className={`info-drip-tile${flip ? ' info-drip-tile--flip' : ''}`}
            style={{
              '--drip-extra-y': `${extraY}px`,
              '--drip-duration': `${durationSec}s`,
            }}
          >
            <img src={src} alt="" width={w} height={h} decoding="async" draggable={false} />
          </div>
        );
      })}
    </div>
  );
}
